import React from "react";
import "../Component/Component.css/LeadersSection.css";
import Rupali from "../Images/Administration.jpg";
import Anil from "../Images/Administration2.png";
import Chandrakant from "../Images/Adminitration3.png";

const leaders = [
  {
    name: "सौ. रूपाली सुजित बेंदे",
    title: "सरपंच",
    img: Rupali, 
    desc: "भूमिका: गावाच्या सर्वांगीण विकासाचे नेतृत्व करणे, ग्रामसभेचे अध्यक्षपद भूषविणे आणि लोकसहभागातून निर्णय घेणे.."
  },
  {
    name: "श्री. अनिल पांडुरंग साळुंखे",
    title: "उपसरपंच",
    img:  Anil,
    desc: "भूमिका: शासकीय योजना अंमलबजावणी, ग्रामपंचायतीचे रेकॉर्ड व्यवस्थापन आणि नागरिकांना आवश्यक सेवा पुरविणे."
  },
  {
    name: "सौ. मनिषा उत्तमराव भरते/-तारळकर",
    title: "ग्रामपंचायत अधिकारी",
    img: Chandrakant, 
    desc: "भूमिका: ग्रामपंचायतीच्या आर्थिक व्यवहारांचे नियोजन आणि हिशोबाचे पारदर्शक व्यवस्थापन.."
  },
];

export default function LeadersSection() {
  return (
    <section className="leaders-section">
      <h2 className="section-title">गावाच्या विकासाचे सूत्रधार</h2>
      <p className="section-subtitle">
        गावाच्या विकासासाठी दिशा ठरविणारे आणि योजनांची अंमलबजावणी पारदर्शकपणे
        करणारे आमचे अधिकारी.
      </p>

      <div className="leaders-grid">
        {leaders.map((leader, index) => (
          <div className="leader-card" key={index}>
            <img src={leader.img} alt={leader.name} className="leader-img" />
            <h3 className="leader-name">{leader.name}</h3>
            <p className="leader-title">पद : {leader.title}</p>
            <p className="leader-desc">{leader.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
